import { render, staticRenderFns } from "./index.vue?vue&type=template&id=69227c70&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.response.css?vue&type=style&index=0&id=69227c70&prod&scoped=true&lang=css&external"
import style1 from "./assets/candidate.css?vue&type=style&index=1&id=69227c70&prod&scoped=true&lang=css&external"
import style2 from "./index.vue?vue&type=style&index=2&id=69227c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69227c70",
  null
  
)

export default component.exports